export const VerificationStatusInfo = {
  VERIFIED: 'Verified',
  UNVERIFIED: 'Unverified',
  FAILED: 'Verification Failed',
  NAME_MISMATCH: 'Name Mismatch with NPI Registry',
  PROVIDER_NPI_EXISTING_IN_SYSTEM: 'Provider NPI Already Exists in System',
  PROVIDER_NPI_EXISTING_IN_PRACTICE: 'Provider NPI Already Exists in Practice',
  NPI_INVALID: 'Invalid NPI',
  FAILED_TO_VALIDATE: 'Failed to Validate',
};

export const VerificationStatus = {
  VERIFIED: 'VERIFIED',
  UNVERIFIED: 'UNVERIFIED',
  FAILED: 'FAILED',
  NAME_MISMATCH: 'NAME_MISMATCH',
  PROVIDER_NPI_EXISTING_IN_SYSTEM: 'PROVIDER_NPI_EXISTING_IN_SYSTEM',
  PROVIDER_NPI_EXISTING_IN_PRACTICE: 'PROVIDER_NPI_EXISTING_IN_PRACTICE',
  NPI_INVALID: 'NPI_INVALID',
  FAILED_TO_VALIDATE: 'FAILED_TO_VALIDATE',
};
